import { Link } from 'react-router-dom'
import Icon from './Icon'

type Page = { to: string; title: string }

/** Previous and Next links through a section's pages, in its own order. */
export default function Pager({ label, previous, next }: { label: string; previous?: Page; next?: Page }) {
  return (
    <nav className="doc-section doc-pager" aria-label={label}>
      {previous && (
        <Link to={previous.to} className="mds-card mds-card--outline mds-card--link doc-pager__link">
          <Icon name="arrow" size={18} className="doc-pager__back" />
          <span className="doc-pager__text">
            <span className="mds-eyebrow">Previous</span>{' '}
            <span className="doc-pager__title">{previous.title}</span>
          </span>
        </Link>
      )}
      {next && (
        <Link to={next.to} className="mds-card mds-card--outline mds-card--link doc-pager__link doc-pager__link--next">
          <span className="doc-pager__text">
            <span className="mds-eyebrow">Next</span>{' '}
            <span className="doc-pager__title">{next.title}</span>
          </span>
          <Icon name="arrow" size={18} />
        </Link>
      )}
    </nav>
  )
}
